import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import MolLink from '../Basepage/parts/Menu/MolLink';

interface UeberUnsState extends BasePageState {}
interface UeberUnsModel {}

export default class UeberUnsPage extends Basepage<
  UeberUnsState,
  UeberUnsModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="ueberUns">
        <b>Wer steht hinter dem Buchbutler?</b>
        <br></br>
        <br></br>
        Menschen, die seit 2014 mit Begeisterung und Leidenschaft online Bücher
        verkaufen und bei denen Ihre Zufriedenheit immer an erster Stelle steht.
        <br></br>
        <br></br>
        Ein Kundenservice-Team, das sich viel Zeit für Sie nimmt und Sie
        persönlich berät.<br></br>
        <br></br>
        Telefonisch sind wir von Montag bis Freitag zwischen 9:00 und 16:00 für
        Sie da.<br></br>
        <br></br>
        <MolLink to="/kontakt" href="/kontakt">
          zur Kontaktseite
        </MolLink>
      </div>
    );
  }

  initState(base: BasePageState): UeberUnsState {
    let newState: UeberUnsState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Über Uns';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Über Uns</span>;
  }
  getType(): string {
    return 'UeberUnsPage';
  }
}
